import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { useAppTFunction } from '@retail/app/i18n';
import { ContainedButton, Dialog, TextButton } from '@shared/components';

interface Props extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  onSubmit: () => void;
}

export const CreateCampaignDialog: React.FC<Props> = ({ children, open, onClose, isLoading, onSubmit }) => {
  const t = useAppTFunction();

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{t('campaign.actions.createCampaign')}</DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        <TextButton onClick={onClose} size="small">
          {t('calculus.cancel')}
        </TextButton>

        <ContainedButton loading={isLoading} onClick={onSubmit} size="small">
          {t('calculus.actions.save')}
        </ContainedButton>
      </DialogActions>
    </Dialog>
  );
};
